import { jsonp } from '../../../base/base';

let cbNum = 0;
const bottomSlidesFn = async config => {
    cbNum += 1;

    return await jsonp(`//c1.m.ifeng.com/client_share_bottom_number?${config}`, {
        jsonpCallback: `wxshareCallback0${cbNum}`,
        cache: false,
    });
};

export { bottomSlidesFn };
